import TagManager, { DataLayerArgs } from 'react-gtm-module';
import { SHA256 } from 'crypto-js';

export const createGTMEvent = (args: DataLayerArgs) =>
  TagManager.dataLayer(args);

export const getGoogleTagManagerUserId = (email: string) =>
  SHA256(email).toString();
